import Swal from "sweetalert2";
import { downloadReceiptPdf } from "../../../../Classes/API/ReceiptsApi";

export const useReceiptDownload = () => {
  const promptAndDownloadReceipt = async (receiptId) => {
    const result = await Swal.fire({
      title: "Success!",
      text: "Accounting Entry Added successfully",
      icon: "success",
      showDenyButton: true,
      confirmButtonText: "OK",
      denyButtonText: "Print Receipt",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#3560AD",
      allowOutsideClick: false,
    });

    if (result.isDenied) {
      try {
        Swal.fire({
          title: "Generating PDF...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const blob = await downloadReceiptPdf(receiptId);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        a.href = url;
        a.download = `receipt-${receiptId}.pdf`;
        document.body.appendChild(a);
        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        Swal.close(); 
        return true;
      } catch (error) {
        console.error("Download failed:", error);
        await Swal.fire({
          title: "Download Error",
          text: "Failed to download the receipt PDF.",
          icon: "error",
          confirmButtonText: "Ok",
        });
        return false;
      }
    }

    return true;
  };

  return { promptAndDownloadReceipt };
};